// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__HKDhN","content":"Menu_content__RQ+Xn","image-div":"Menu_image-div__QDW2V","image_all":"Menu_image_all__hq3iH"};